export default __webpack_public_path__ + "static/media/iconBench.a7f9f7ea.svg";